import { action, PayloadAction } from 'typesafe-actions';

import { MapObject } from '../../types/general';
import { ContextPropertyNames } from '../../features/featureProperties';
import { CommonContextActionTypes } from './actionTypes';

export type MissingPropertiesPayload = {
    id: number;
    missingProperties: ContextPropertyNames;
}

export const loadMissingProperties = (missingProperties: ContextPropertyNames): PayloadAction<string, string[]> => {
    return action(CommonContextActionTypes.LOAD_MISSING_PROPERTIES, missingProperties);
};
export const refreshMissingProperties = (id: number, missingProperties: ContextPropertyNames): PayloadAction<string, MissingPropertiesPayload> => {
    return action(CommonContextActionTypes.REFRESH_MISSING_PROPERTIES, { id, missingProperties });
};
export const replaceContext = (context: MapObject): PayloadAction<string, MapObject> => {
    return action(CommonContextActionTypes.REPLACE_CONTEXT, context);
};
